<div class="expandeable-list" [ngClass]="{'open-expandeable-list': !listIsClose}">
  <p class="listTitle" (click)=toogleList()>{{ listTitle }}</p>
  <div class="app-list-wrapper">
    <app-list-item [listIsClose]="listIsClose" *ngFor="let listItem of listItems" [listItem]="listItem">
    </app-list-item>
  </div>
</div>